import { useTranslation } from 'react-i18next'

import { AccordionAnimatedContent } from '../../../Accordion'
import { AIButtonIconFlat, AIButtonTextGrey } from '../../../AIButton'
import { Avatar, AVATAR_HEIGHT_32 } from '../../../Avatar'
import { getVerticalIconChevronDirection, IconChevron } from '../../../Icon'
import Text from '../../../Text'
import {
  QA_NAME_ATTACH_SERVICE_REQUESTS_AI_COLLAPSE_BUTTON,
  QA_NAME_ATTACH_SERVICE_REQUESTS_AI_REFRESH_BUTTON,
} from '../AttachServiceRequestsModal.constants'

import { AttachServiceRequestsModalAISuggestionsPanelRow } from './AttachServiceRequestsModalAISuggestionsPanelRow'

import * as styles from './AttachServiceRequestsModalAISuggestionsPanel.module.css'

import RefreshIcon from '../../../../icons/refresh.svg'
import AIAvatarIcon from '../../../../icons/unique/ai/avatar.svg'
import ChevronDownIcon from '../../../../icons/unique/ai/chevron-down.svg'

function AttachServiceRequestsModalAISuggestionsPanel({
  isCollapsed,
  selectedId,
  suggestions,
  onCollapseToggle,
  onRefresh,
  onSelect,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <Avatar
          Icon={AIAvatarIcon}
          iconSize={AVATAR_HEIGHT_32}
          size={AVATAR_HEIGHT_32}
        />
        <Text className={styles.title}>
          {t('Modal.AttachServiceRequestsAIPanelTitleKey', {
            count: suggestions.length,
          })}
        </Text>
        <AIButtonIconFlat
          Icon={IconChevron}
          beforeIconProps={{
            iconProps: {
              Icon: ChevronDownIcon,
              direction: getVerticalIconChevronDirection(!isCollapsed),
            },
          }}
          className={styles.collapseButton}
          qaName={QA_NAME_ATTACH_SERVICE_REQUESTS_AI_COLLAPSE_BUTTON}
          onClick={onCollapseToggle}
        />
      </div>
      <AccordionAnimatedContent isOpen={!isCollapsed}>
        <div className={styles.rows}>
          {suggestions.map(suggestion => (
            <AttachServiceRequestsModalAISuggestionsPanelRow
              isSelected={selectedId === suggestion.request_id}
              key={suggestion.request_id}
              suggestion={suggestion}
              onSelect={onSelect}
            />
          ))}
        </div>
        <div className={styles.buttons}>
          <AIButtonTextGrey
            beforeIconProps={{ Icon: RefreshIcon }}
            qaName={QA_NAME_ATTACH_SERVICE_REQUESTS_AI_REFRESH_BUTTON}
            text={t('Common.RefreshButtonTextKey')}
            onClick={onRefresh}
          />
        </div>
      </AccordionAnimatedContent>
    </div>
  )
}

export default AttachServiceRequestsModalAISuggestionsPanel
